import { Grid, Stack, Typography } from "@mui/material";
import { WhiteBox } from "@foodpilot/foods";
import { useTheme } from "@mui/material";
import { FoodsTooltip } from "@foodpilot/foods";
import { FoodsIcon } from "@foodpilot/foods";
import { SxProps } from "@mui/material";

type IndicatorNodeProps = {
    title: string | null;
    subtitle?: string | null;
    description?: string | null;
    sx?: SxProps;
};
export const IndicatorNode = (props: IndicatorNodeProps) => {
    const theme = useTheme();
    const { title, subtitle, description, sx } = props;
    return (
        <Grid item sm={12} md={6} lg={4}>
            <WhiteBox
                sx={{
                    padding: theme.spacing(1.5, 4),
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    ...sx,
                }}
            >
                <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={2}>
                    {title && (
                        <Stack direction="row" alignItems="center" justifyContent="flex-start" my={theme.spacing(2)}>
                            <Typography variant="body-medium" color={theme.custom.grey[1600]}>
                                {title}
                            </Typography>
                        </Stack>
                    )}
                    {subtitle && (
                        <FoodsTooltip title={subtitle} placement="top" arrow width="unset">
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="flex-end"
                                pt={theme.spacing(2.25)}
                            >
                                <FoodsIcon icon="information" size={3} />
                            </Stack>
                        </FoodsTooltip>
                    )}
                </Stack>
                {description && (
                    <Typography
                        dangerouslySetInnerHTML={{ __html: description }}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "space-between",
                            whiteSpace: "pre-wrap",
                            "& p": {
                                whiteSpace: "pre-wrap",
                                my: theme.spacing(0.75),
                                a: {
                                    color: theme.palette.primary[400],
                                },
                            },
                            "& hr": {
                                border: "none",
                                height: "1px",
                                backgroundColor: theme.palette.divider,
                                width: `calc(100% + ${theme.spacing(8)})`,
                                ml: theme.spacing(-4),
                                my: theme.spacing(2.25),
                            },
                            "& .label": {
                                border: `1px solid ${theme.palette.divider}`,
                                borderRadius: theme.spacing(1),
                                padding: theme.spacing(0.5, 1),
                                backgroundColor: theme.palette.grey[200],
                            },
                        }}
                    />
                )}
            </WhiteBox>
        </Grid>
    );
};

export default IndicatorNode;
